export default "__VITE_ASSET__DUIVwG6n__"